export default __webpack_public_path__ + "static/pattern-4@2x-875c3ca76b43e9b54bf4684379e5d0ab.png";